import { isDefine, isNumeric } from 'helpers';

export const percentage = ({ numerator, denominator, decimals = 2 }) => {
  if (denominator === 0) return 0;

  return parseFloat(((numerator / denominator) * 100).toFixed(decimals));
};

export const toFixed = (number = 0, fractionDigits = 2) => {
  return isDefine(number) && isNumeric(number) ? parseFloat(number.toFixed(fractionDigits)) : 0;
};
